<video class="login-video" poster="assets/poster-video.png" id="bgvid" playsinline autoplay muted loop>
  <source src="assets/video.webm" type="video/webm">
  <source src="assets/video.mp4" type="video/mp4">
</video>

<div class="login-container">
  <div class="login-content">
    <div class="login-box">
      <div class="login-logo">
        <img src="assets/logo.svg" alt="Logo">
      </div>

      <h3 class="text-center">Iniciar Sesión</h3>
      
      <!-- Si estamos en dummy, mostramos el formulario -->
      <ng-container *ngIf="env.useDummyLogin; else oidcBlock">
        <form (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="username" class="text-primary">Correo Electrónico</label>
            <input
              type="text"
              class="input"
              id="username"
              [(ngModel)]="username"
              name="username"
              placeholder="Ingrese su correo"
              required
              autocomplete="username"
            />
          </div>
          <div class="mb-3">
            <label for="password" class="text-primary">Contraseña</label>
            <input
              type="password"
              class="input"
              id="password"
              [(ngModel)]="password"
              name="password"
              placeholder="Ingrese su contraseña"
              required
              autocomplete="current-password"
            />
          </div>
          <button type="submit" class="button button-primary">Ingresar</button>
          <div class="text-center mt-3">
            <a href="#" class="text-secondary">¿Olvidaste tu contraseña?</a>
          </div>
          <p *ngIf="errorMessage" class="text-danger text-center mt-3">{{ errorMessage }}</p>
        </form>
      </ng-container>

      <!-- Si no es dummy, mostramos botón OIDC -->
      <ng-template #oidcBlock>
        <button class="button button-primary w-100" (click)="onOidcLogin()">
          Iniciar sesión con Cognito
        </button>

        <button type="button" class="button w-100 mt-2" (click)="onForceLogout()">
          Cerrar sesión (forzar)
        </button>
      </ng-template>
      
    </div>
  </div>
</div>
